import { render, staticRenderFns } from "./-CreateProject.vue?vue&type=template&id=0f5ae736&scoped=true&"
import script from "./-CreateProject.vue?vue&type=script&lang=js&"
export * from "./-CreateProject.vue?vue&type=script&lang=js&"
import style0 from "./-CreateProject.vue?vue&type=style&index=0&id=0f5ae736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ae736",
  null
  
)

export default component.exports